// Read from environment variables
export const VITE_PUBLIC_POSTHOG_KEY =
  import.meta.env.VITE_POSTHOG_API_KEY || "";
export const VITE_PUBLIC_POSTHOG_HOST =
  import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com";

export const options = {
  api_host: VITE_PUBLIC_POSTHOG_HOST,
  capture_pageview: false,
  person_profiles: "identified_only", // Only create profiles for identified users

  // Session Replay
  session_recording: {
    maskAllInputs: false,
    maskInputOptions: {
      password: true, // Always mask passwords
    },
  },

  // Include hash in $pathname for proper path tracking in SPAs with hash-based routing
  // This ensures routes like /#home, /#settings appear as distinct pages in Paths insights
  before_send: (event: any) => {
    if (event?.properties?.$current_url) {
      try {
        const parsed = new URL(event.properties.$current_url);
        if (parsed.hash) {
          event.properties.$pathname = parsed.pathname + parsed.hash;
        }
      } catch {
        // If URL parsing fails, leave $pathname unchanged
      }
    }
    return event;
  },

  // Optional: Set static super properties that never change
  loaded: (posthog: any) => {
    posthog.register({
      environment: import.meta.env.MODE, // "development" or "production"
    });
  },
};

// Check if PostHog should be disabled (no API key or explicitly disabled)
export const isPostHogDisabled =
  !VITE_PUBLIC_POSTHOG_KEY ||
  import.meta.env.VITE_DISABLE_POSTHOG_LOCAL === "true";

// Conditional PostHog key and options
export const getPostHogKey = () =>
  isPostHogDisabled ? "" : VITE_PUBLIC_POSTHOG_KEY;
export const getPostHogOptions = () => (isPostHogDisabled ? {} : options);

export function detectPlatform() {
  // Check if running in Docker
  const isDocker =
    import.meta.env.VITE_DOCKER === "true" ||
    import.meta.env.VITE_RUNTIME === "docker";

  if (isDocker) {
    return "docker";
  }

  // Check if Electron
  const isElectron = (window as any)?.isElectron;

  if (isElectron) {
    // Detect OS within Electron using userAgent
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes("mac") || userAgent.includes("darwin")) {
      return "mac";
    } else if (userAgent.includes("win")) {
      return "win";
    }
    return "electron"; // fallback
  }

  // npm package running in browser
  return "npm";
}

export function detectEnvironment() {
  return import.meta.env.ENVIRONMENT;
}
